import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { ProjectListItem } from 'components/ProjectListing';

const StyledListing = styled.div`

`;

const List = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  padding-top: 1rem;
  padding-bottom: 1rem;
  list-style-type: none;
  margin-left: 0;
`;

export default class ProjectListing extends Component {
  render() {
    const { projects } = this.props;
    // GraphQL query on index.jsx page limits to 3 projects
    return (
      <StyledListing>
        <List>
          {projects.map(post => {
            let projectcategories = false;
            if (post.node.data.categories[0].projectcategory) {
              projectcategories = post.node.data.categories.map(c => c.projectcategory.document[0].data);
            }
            return <ProjectListItem key={post.node.uid} node={post.node} projectcategories={projectcategories} />;
          })}
        </List>
      </StyledListing>
    );
  }
}

ProjectListing.propTypes = {
  projects: PropTypes.array.isRequired,
};
